import * as React from "react";

function Pin(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22.087l.585-.51C17.5 17.284 20 13.535 20 10.24c0-4.666-3.642-8-8-8-4.358 0-8 3.334-8 8 0 3.295 2.499 7.044 7.415 11.337l.585.51zm0-2.368c-4.172-3.76-6.222-6.946-6.222-9.479 0-3.647 2.812-6.222 6.222-6.222 3.41 0 6.222 2.575 6.222 6.223 0 2.532-2.05 5.718-6.222 9.478zm0-13.923a4.444 4.444 0 110 8.889 4.444 4.444 0 010-8.889zm-2.667 4.445a2.667 2.667 0 115.334 0 2.667 2.667 0 01-5.334 0z"
      />
    </svg>
  );
}

export default Pin;
